// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".error-page{display:flex;flex-direction:column;align-items:center;justify-content:center;min-height:100vh;text-align:center}.error-page a{color:#fff}.error-page a:hover{color:inherit}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
